import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';

import RequestState from '../../../types/RequestState';
import BlockSpinner from '../BlockSpinner';
import Error from '../../../models/Error';
import { modelOf } from '../../../prop-types';
import ErrorHandler from '../ErrorHandler';

@observer
class ContentForState extends Component {
  render() {
    const { state, forLoaded, error, errorHandler: ErrorHandler } = this.props;

    let content;
    switch (state) {
      case RequestState.LOADED:
        content = forLoaded && forLoaded();
        break;
      case RequestState.LOADING:
        content = <BlockSpinner />;
        break;
      case RequestState.ERROR:
        content = <ErrorHandler error={error} />;
        break;
      default:
        content = null;
    }

    return content;
  }
}

ContentForState.propTypes = {
  state: PropTypes.string,
  forLoaded: PropTypes.func.isRequired,
  error: PropTypes.oneOfType([modelOf(Error), PropTypes.object]),
  errorHandler: PropTypes.func
};

ContentForState.defaultProps = {
  errorHandler: ErrorHandler
};

export default ContentForState;



// WEBPACK FOOTER //
// ./src/components/loader/ContentForState/index.jsx